export function downloadFromBase64(base64Data, fileName, mimeType) {
    if (mimeType === void 0) { mimeType = "text/plain"; }
    // Decode the Base64 data
    var binaryData = atob(base64Data);
    // Convert binary data to a Uint8Array
    var byteArray = new Uint8Array(binaryData.length);
    for (var i = 0; i < binaryData.length; i++) {
        byteArray[i] = binaryData.charCodeAt(i);
    }
    // Create a Blob from the Uint8Array
    var blob = new Blob([byteArray], { type: mimeType });
    // Create a temporary link element
    var link = document.createElement("a");
    link.href = URL.createObjectURL(blob); // Create a URL for the blob
    link.download = fileName; // Set the desired file name
    // Trigger the download
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}
